/**
 * DashboardCalendarBridgeContext
 *
 * Bridge context that exposes Dashboard-scope identifiers needed by the
 * extracted Calendar JSX (now in AppointmentsTab.jsx).
 *
 * This context is intentionally temporary — it exists so we can lift the
 * 2400-line Calendar JSX block out of App.js without having to first
 * untangle every handler from Dashboard's local scope.  Stage 3 will
 * gradually move drag/resize handlers into custom hooks and display
 * helpers into `utils/calendar.js`, at which point this context shrinks
 * and finally disappears.
 *
 * Section-1 identifiers (appointments state) come from useAppointments()
 * directly; this bridge only supplies Section-3 (Dashboard-scope).
 *
 * Created Feb 2026 as part of Calendar Stage 2B refactor.
 */

import React, { createContext, useContext } from 'react';

const DashboardCalendarBridgeContext = createContext(null);

export const DashboardCalendarBridgeProvider = ({ value, children }) => (
  <DashboardCalendarBridgeContext.Provider value={value}>
    {children}
  </DashboardCalendarBridgeContext.Provider>
);

export const useDashboardCalendarBridge = () => {
  const ctx = useContext(DashboardCalendarBridgeContext);
  if (ctx === null) {
    throw new Error(
      'useDashboardCalendarBridge must be used inside DashboardCalendarBridgeProvider'
    );
  }
  return ctx;
};

export default DashboardCalendarBridgeContext;
